<template lang="pug">
.dashboard
  h3.text-primary.pt-4.pb-4 Recent activities
  b-row
    b-col(xs='12')
      template(v-for='(project, index) in items')
        b-btn.dashboard__btn.checklist-item-toggle.text-left.text-white.mt-3(block href='#' v-b-toggle="'accordion' + index" variant='primary')
          h4.mb-0 {{ project.name }}
          small {{ projectType(project.type) }}
          i.icon-arrow-down.accordion-icon
        b-collapse(:id="'accordion' + index" :accordion="'accordion' + index" role='tabpanel')
          b-card
            b-table(
              hover
              striped
              class='table-responsive-sm'
              :items='project.recent_items'
              :fields='fields'
            )
              template(slot="checked_at" slot-scope='data')
                div(v-if='canGetItemInfo(data.item)') {{ data.item.checked_at }}
                div.customer_information(v-else)

              template(slot="component_name" slot-scope='data' v-if='canGetItemInfo(data.item)') {{ data.item.component_name }}
              template(slot="notes" slot-scope='data' v-if='canGetItemInfo(data.item)') {{ data.item.notes }}
              template(slot="report_number" slot-scope='data' v-if='canGetItemInfo(data.item)') {{ data.item.report_number }}

              template(slot="checklist_show" slot-scope='data' v-if='canGetItemInfo(data.item)')
                router-link.text-primary.table-action(
                  :to="{ name: 'Show inspection', params: { id: data.item.checklist_id } }"
                  title='View details'
                ) View details

              template(slot="status" slot-scope='data')
                i.font-weight-bold(:class="getIcon(data.item)")

              template(slot='report_file' slot-scope='data' v-if='canGetItemInfo(data.item)')
                template(v-if='canGetDraftReport(data.item)')
                  b-button.mb-3.text-white(
                    variant='warning'
                    type='button'
                    :href='data.item.draft_report_url'
                    target='_blank'
                    :disabled='(data.item.draft_report_url ? false : true)'
                  ) Download draft report
                  br
                template(v-if='canGetFinalReport(data.item)')
                  b-button(
                    v-if='canGetFinalReport(data.item)'
                    variant='primary'
                    type='button'
                    :href='data.item.final_report_url'
                    target='_blank'
                    :disabled='(data.item.final_report_url ? false : true)'
                  ) Download final report

      nav.pt-5
        b-pagination-nav(
          :link-gen='linkGen'
          :number-of-pages='totalPages'
          v-model='currentPage'
          prev-text='Prev'
          next-text='Next'
        )
</template>

<script>
  import _ from 'lodash'
  import server from '@/server'
  import Policeman from '@/utils/Policeman/policeman'
  import Messages from '@/utils/notificationsMsg'
  import RouteGen from '@/utils/apiRoutes'
  import { normalizer, formatProjectType } from '@/utils/resourceNormalizer'

  import { mapGetters } from 'vuex'

  export default {
    data () {
      return {
        items: [],
        currentPage: null,
        totalPages: null,
        perPage: null,
        totalRows: null,
        nextPage: null,
        prevPage: null,
        sortBy: '',
        sortDesc: false,
        fields: {
          status: { label: 'Status' },
          checklist_show: { label: ' ' },
          checked_at: { label: 'Checked at', class: 'checked_at_table_field', sortable: true },
          component_name: { label: 'Part', sortable: true },
          notes: { label: 'Notes', class: 'notes_table_field' },
          report_number: { label: 'Report number', sortable: true },
          report_file: { label: ' ' }
        }
      }
    },
    mounted () {
      let currentPermissions = this.$route.meta.roles
      if (!Policeman.authorize(currentPermissions)) {
        this.showNotification(401)
        this.$route.push({ name: 'Home' })
      }
      this.getResources()
    },
    computed: {
      ...mapGetters({
        currentUser: 'currentUser'
      })
    },
    watch: {
      currentPage (newPage, oldPage) {
        if (newPage != null && oldPage != null && newPage > 0 && oldPage > 0) {
          let sort = this.$data.sortBy
          let desc = this.$data.desc
          this.getResources(newPage, sort, desc)
        }
      }
    },
    methods: {
      projectType (key) {
        let type = formatProjectType(key)
        if (typeof type === 'string') {
          return type
        } else {
          return ''
        }
      },
      getResources (page = 1, sort = 'updated_at', desc = true) {
        if (sort === null) { sort = 'updated_at' }
        let route = RouteGen.index('project')
        let order = (desc) ? 'desc' : 'asc'
        server.get(route,
          {
            params: {
              page: page,
              per_page: 20,
              'q[s]': (sort + ' ' + order),
              'include': 'recent-checklist-items'
            }
          })
          .then(res => {
            this.setPager(res.headers)
            let formattedResources = res.data['projects'].filter(resource => {
              if (resource.recent_checklists_items) { return true }
            }).map(resource => {
              return normalizer('dashboard', resource)
            })
            this.$set(this.$data, 'items', _.compact(formattedResources))
          })
          .catch(err => {
            console.log(err)
          })
      },
      getIcon (item) {
        if (item.checked_at && item.defective) { return 'icon-close text-danger' }
        if (!item.checked_at) { return 'icon-clock text-warning' }
        return 'icon-check text-primary'
      },
      getRowCount (items) {
        return items.length
      },
      showNotification (status) {
        return this.showMessage(Messages.byStatus(status))
      },
      linkGen (pageNum) {
        return { path: '?page=' + pageNum }
      },
      setPager (data) {
        this.$set(this.$data, 'nextPage', parseInt(data['x-next-page']))
        this.$set(this.$data, 'prevPage', parseInt(data['x-prev-page']))
        this.$set(this.$data, 'currentPage', parseInt(data['x-page']))
        this.$set(this.$data, 'perPage', parseInt(data['x-per-page']))
        this.$set(this.$data, 'totalRows', parseInt(data['x-total']))
        this.$set(this.$data, 'totalPages', parseInt(data['x-total-pages']))
      },
      sortingChanged (variation) {
        this.getResources(this.$data.currentPage, variation.sortBy, variation.sortDesc)
      },
      canGetItemInfo (item) {
        if (this.currentUser.role === 'customer' && !item.checked) { return false }
        return true
      },
      canGetDraftReport (item) {
        if (this.currentUser.role === 'customer' || !item.draft_report_url) { return false }
        return true
      },
      canGetFinalReport (item) {
        if (!item.checked || !item.final_report_url) { return false }
        return true
      }
    },
    notifications: {
      showMessage: {}
    }
  }
</script>

<style lang="sass">
  .dashboard thead th
    border: 0 !important
    vertical-align: top !important

  .notes_table_field
    display: -webkit-box
    -webkit-line-clamp: 3
    -webkit-box-orient: vertical
    max-width: 50ch
    p
      overflow: hidden
      margin: 0

  .checked_at_table_field
    min-width: 12ch

  .dashboard .checked_at_table_field
    .customer_information
      position: relative
      &:before
        content: 'The operator has not completed the check yet'
        position: absolute
        width: 20rem

</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue